<div *ngIf="isTokenValid === null">
    <div class="main-linkedin-callback">
        <div class="container"> 
            <img src="/assets/spinner.gif" [alt]="'linkedinCallback.loading' | translate" class="spinner">
        </div>
    </div>
</div>

  <div *ngIf="isTokenValid">
    <div class="main-linkedin-callback">
      <div class="container">
        <div class="left-section">
          <img src="/assets/conectio-logo.png" alt="Conectio" class="logo">
          <h2>{{ 'linkedinCallback.successTitle' | translate }}</h2>
          <p>{{ 'linkedinCallback.successText' | translate }}</p>
          <p>{{ 'linkedinCallback.successNext' | translate }}</p>
          <button mat-raised-button color="primary" type="submit" (click)="continueRegister()">
            {{ 'linkedinCallback.continue' | translate }}
          </button>
        </div>
        <div class="right-section">
          <img src="/assets/11066756.jpg" alt="" class="illustration">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isTokenValid === false">
    <div class="error-template">
      <div class="main-linkedin-callback">
          <div class="container">
            <div class="left-section">
              <img src="/assets/conectio-logo.png" alt="Conectio" class="logo">
              <h2 class="error-title">{{ 'linkedinCallback.errorTitle' | translate }}</h2>
              <p>{{ 'linkedinCallback.errorText' | translate }}<br>{{ 'linkedinCallback.errorCode' | translate: { code: 'L-001' } }}</p>
            </div>
            <div class="right-section">
              <img src="/assets/error-token.webp" alt="" class="illustration">
            </div>
          </div>
        </div>
    </div>
  </div>